/** Read by the pre-paint script in index.html: it applies a dark theme only when this holds 'on'. */
export const THEME_CONTROL_STORAGE_KEY = 'pmp-theme-control';

/**
 * Records whether the environment offers the theme control. Without it the app is always light,
 * so a dark theme already on the document is removed.
 */
export const syncThemeControl = (enabled: boolean, root: HTMLElement): void => {
  try {
    globalThis.localStorage?.setItem(THEME_CONTROL_STORAGE_KEY, enabled ? 'on' : 'off');
  } catch {
    /* storage unavailable: the pre-paint script renders light */
  }
  if (!enabled) delete root.dataset.theme;
};
